import React, {Component} from 'react';
import styled from 'styled-components';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { baseUrl } from './url'



const InputWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const FormHeader = styled.h6`
    font-weight: bold;
    font-size: 18px;
    line-height: 18px;
    color: #6C63FF;
    margin-bottom: 59px;
`;

const InputWrapperText = styled.p`
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #212B36;
    font-weight: 500;
    margin: 0;
    padding: 0;
    margin-bottom: 7px;


`;

const Input = styled.input`
    width: 242px;
    height: 36px;
    background: #F9FAFB;
    border: 1px solid #DFE3E8;
    box-sizing: border-box;
    border-radius: 3px;
    padding: 0;
    margin-bottom: 36px;
`;

const ArchiveButton = styled.button`
    width: 147px;
    height: 36px;
    background: #BC3E06;
    border: 1px solid #AC3806;
    box-sizing: border-box;
    box-shadow: 0px 1px 0px rgba(22, 29, 37, 0.1), inset 0px 1px 0px rgba(255, 255, 255, 0.06);
    border-radius: 3px;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #FFFFFF;
`;

const ConfirmPasswordWrapper = styled.div`
    background: #FFFFFF;
    box-shadow: 0px 1px 3px rgba(63, 63, 68, 0.15), 0px 0px 0px rgba(63, 63, 68, 0.05);
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 532px;
    padding: 55px;

`;



class ConfirmPassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            password: '',
            patientId: this.props.id
        }

        this.handleArchive = this.handleArchive.bind(this)
    }

    notify = (message) => toast.success(message);

    handleArchive() {
      if(!this.state.password) {
        alert('Password is required.')
      }


      let token = localStorage.getItem("access_token")

      fetch(`${baseUrl}/admin/users/${this.props.action}/${this.props.userType}/${this.props.userID}`, {
          method: 'PUT',
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': token
          },
          body: JSON.stringify({
              password: this.state.password
          })
      }).then((response) => response.json())
      .then(userResponse => {
          this.notify(userResponse.message)

          setTimeout(() => {
              window.location.href = '/users'
          }, 2000)

      })
      .catch(error => {
        alert(error.message || 'Error archiving patient')
      })
    }

    render() {
        return(
            <ConfirmPasswordWrapper>
                <FormHeader>Enter your password to archive user</FormHeader>
                <InputWrapper>
                    <InputWrapperText>Password</InputWrapperText>
                    <Input type="text" onChange={(evt) => this.setState({password: evt.target.value})} />
                </InputWrapper>

                <ArchiveButton onClick={this.handleArchive}>{(this.props.action === 'restore') ? 'Restore User' : 'Archive User'}</ArchiveButton>
                <ToastContainer />
            </ConfirmPasswordWrapper>
        )
    }
}

export default ConfirmPassword;



// WEBPACK FOOTER //
// ./src/components/ConfirmPassword.js